<template>
  <div class="dimed wrap" v-if="emoneyCheckYn == true">
    <div class="layer" :class="{'layer--bottom': currentUrl.indexOf('idle') >= 0}">
      <div class="layer__header fix-h">
        <div class="lyr-title">{{ $t('Modal.EMoneyCheck.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.EMoneyCheck.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.EMoneyCheck.msg3') }}</div>
      </div>
      <div class="layer__body no-margin">
        <img src="@/assets/images/user/artwork_popup_emoney_3d_jp.gif" alt="" class="img-size" />
        <div class="balance">
          <span class="dt">{{ $t('Modal.EMoneyCheck.msg4') }}</span>
          <span class="dd ft-point">{{ emoney }}{{ currUnitText }}</span>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--shadow btn--xlg btn--color btn-anim" @mouseup="$emit('closeEmoneyCheck')">
          {{ $t('Modal.EMoneyCheck.msg6') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'emoneyCheck',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      currentUrl: window.location.pathname,
      currUnitText: this.$store.getters.getCurrUnitText,
    };
  },
  watch: {
    emoneyCheckYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00053', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  props: {
    emoneyCheckYn: Boolean,
    emoney: Number,
  },
  methods: {},
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style scoped></style>
